var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.2504C3 11.8707 3.28201 11.5569 3.64808 11.5071L3.74985 11.5003L11 11.499L11 4.24596C11 3.83174 11.3358 3.49596 11.75 3.49596C12.1297 3.49596 12.4435 3.77811 12.4932 4.14419L12.5 4.24596L12.5 11.499L19.7491 11.497C20.1633 11.4969 20.4993 11.8326 20.4993 12.2468C20.4993 12.6265 20.2173 12.9404 19.8512 12.9901L19.7494 12.997L12.5 12.999V20.248C12.5 20.6623 12.1642 20.998 11.75 20.998C11.3703 20.998 11.0565 20.7159 11.0068 20.3498L11 20.248V12.999L3.75015 13.0003C3.33594 13.0003 3 12.6646 3 12.2504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.af0c2025ed0b6bab38f70ec6ad638a9d.svg";
export { ForwardRef as ReactComponent };